import { random } from "rambda"

import { E2E_TEST } from "../config/constants"

export const CONFIG = {
  DONT_HIT_CHANCE: [5, 20],
  DONTHITIT_RANGE: [15, 25] as const,
  ERROR_VALUE: 1.5,
  HIT_WORDS_COUNT: 8,
  HITIT_CHANCE: 0.25,
  HITIT_RANGE: [3, 8] as const,
  INIT_COUNT: 10,
  PAUSE_RANGE: [300, 800],
  WORD_VIEWING_TIME: [800, 1400],
} as const

export const SCORE_STORAGE_KEY = "dont-hit-it-scores"

export function getPauseDuration(): number {
  if (E2E_TEST) return 0
  const [min, max] = CONFIG.PAUSE_RANGE
  const result = min + Math.floor(Math.random() * (max - min + 1))
  return result
}

export function getWordViewingTime(): number {
  if (E2E_TEST) return 500
  return random(CONFIG.WORD_VIEWING_TIME[0], CONFIG.WORD_VIEWING_TIME[1])
}
